<template>
  <v-card class="product-card">
    <div :aspect-ratio="1" class="product-card__responsive">
      <div class="product-card__image" :style="{ 'background-image': productImage }"></div>
      <slot name="check"></slot>
    </div>
    <template v-if="isThailandPostmart">
      <v-card-text>
        <div class="name">{{ value.product_title | truncate(50) }}</div>
        <div>
          <div>
            SKU:<span class="primary--text"> {{ value.sku }}</span>
          </div>
          <div>
            Sale:<span class="primary--text"> {{ value.product_sale_net }}</span>
          </div>
          <div>
            Price:<span class="primary--text"> {{ value.product_price }}</span>
          </div>
        </div>
      </v-card-text>
    </template>
    <template v-else>
      <v-card-text>
        <div class="name">{{ value.name }}</div>
        <div
          v-if="discountPriceRange != priceRange"
          class="discount grey--text text--lighten-1 caption"
        >
          {{ priceRange }}
        </div>
        <div v-else class="price primary--text title">
          <template v-if="discountPriceRange != priceRange">{{ discountPriceRange }}</template>
          <template v-else>{{ priceRange }}</template>
        </div>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import numeral from 'numeral'
import { PAGE_GROUP } from '@/constants/page.js'
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        name: '',
        photourl: ''
      })
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    isThailandPostmart() {
      return [PAGE_GROUP.THAILANDPOSTMART].includes(this.selectedBot.page_group)
    },
    productImage() {
      if (this.isThailandPostmart) {
        return `url('${this.value.product_thumb}')`
      } else {
        const images = this.value.photourl ? this.value.photourl.split(';;') : null
        if (images) {
          return `url('${images[0]}')`
        } else {
          return `url('/static/img/assets/_global/default-photo.png')`
        }
      }
    },
    currencySign: function () {
      if (this.value && this.value.currency) {
        switch (this.value.currency.toUpperCase()) {
          case 'THB':
            return '฿'
          case 'MMK':
            return 'K'
          case 'GBP':
            return '£'
          case 'PHP':
            return '₱'
          default:
            return '$'
        }
      }
      return '$'
    },
    priceRange: function () {
      var min = 0
      var max = 0

      for (let index = 0; index < this.value.productstock.length; index++) {
        var price =
          this.value.productstock[index][3] == null || this.value.productstock[index][3] == ''
            ? parseFloat(this.value.price)
            : parseFloat(this.value.productstock[index][3])
        if (index == 0) {
          min = price
          max = price
        } else {
          if (price > max) {
            max = price
          }
          if (price < min) {
            min = price
          }
        }
      }

      if (min == max) {
        return this.currencySign + numeral(min).format('0,0.00')
      } else {
        return (
          this.currencySign +
          numeral(min).format('0,0.00') +
          ' - ' +
          this.currencySign +
          numeral(max).format('0,0.00')
        )
      }
    },
    discountPriceRange: function () {
      var min = 0
      var max = 0

      for (let index = 0; index < this.value.productstock.length; index++) {
        var price =
          this.value.productstock[index][3] == null || this.value.productstock[index][3] == ''
            ? parseFloat(this.value.discountprice) === 0
              ? parseFloat(this.value.price)
              : parseFloat(this.value.discountprice)
            : parseFloat(this.value.productstock[index][3])
        var discountprice =
          this.value.productstock[index][4] == null || this.value.productstock[index][4] == ''
            ? price
            : parseFloat(this.value.productstock[index][4])

        if (index == 0) {
          min = discountprice
          max = discountprice
        } else {
          if (discountprice > max) {
            max = discountprice
          }
          if (discountprice < min) {
            min = discountprice
          }
        }
      }

      if (min == max) {
        return this.currencySign + numeral(min).format('0,0.00')
      } else {
        return (
          this.currencySign +
          numeral(min).format('0,0.00') +
          ' - ' +
          this.currencySign +
          numeral(max).format('0,0.00')
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.product-card {
  position: relative;
  width: 100%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .product-card__responsive {
    position: relative;
  }

  .product-card__image {
    background-color: #eee;
    height: 100%;
    background-position: center;
    background-size: cover;
    max-height: 250px;
    aspect-ratio: 1;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/components/ProductMeta.vue